
import React, { useState } from "react"
import PropTypes from "prop-types"

import {
  Backdrop,
  Section,
  Container,
  ParticleLayer,
  HeaderRow,
  Eyebrow,
  CategoryTabs,
  CategoryButton,
  MembersRow,
  MemberCard,
  MemberPhoto,
  MemberSlip,
  MemberName,
  MemberPosition,
} from "./styles"

import ParticlesConfig from "./particles.json"

const CATEGORIES = ["Leadership", "Science", "Computational"]

// Prismic has no "team category" field, so membership is mapped here by
// name. Gustaf Hemberg intentionally appears in both Leadership and
// Science.
const CATEGORY_MAP = {
  "Gustaf Hemberg": ["Leadership", "Science"],
  "Juliet Sword": ["Leadership"],
  "Ben Davis, FRS": ["Leadership"],
  "Hugh Macfarlane": ["Leadership"],
  "Malcolm Spain": ["Science"],
  "Sihong Chen": ["Science"],
  "Darshan Rudakiya": ["Science"],
  "Jake Foster": ["Science"],
  "Ryan Palmer": ["Science"],
  "Daniel Casey": ["Science"],
  "Christopher Wright": ["Computational"],
  "Maranga Mokaya": ["Computational"],
  "Osmin Lacombe": ["Computational"],
}

const Team = ({ data }) => {
  const { team_title } = data.primary
  const [activeCategory, setActiveCategory] = useState(CATEGORIES[0])

  const filteredItems = data.items.filter(item => {
    const name = item.team_member_name && item.team_member_name.text
    const categories = CATEGORY_MAP[name] || []
    return categories.includes(activeCategory)
  })

  return (
    <Backdrop id="team">
      <Section>
        <Container>
          <HeaderRow>
            <Eyebrow>{team_title.text}</Eyebrow>

            <CategoryTabs>
              {CATEGORIES.map(category => (
                <CategoryButton
                  key={category}
                  active={category === activeCategory}
                  onClick={() => setActiveCategory(category)}
                >
                  {category}
                </CategoryButton>
              ))}
            </CategoryTabs>
          </HeaderRow>

          <MembersRow>
            {filteredItems.map((item, i) => {
              const {
                team_member_portrait,
                team_member_link,
                team_member_name,
                team_member_position,
              } = item
              const name = team_member_name && team_member_name.text

              return (
                <MemberCard
                  key={`team-member-${name || i}`}
                  href={team_member_link && team_member_link.url}
                >
                  <MemberPhoto image={team_member_portrait && team_member_portrait.url} />
                  <MemberSlip>
                    <MemberName>{name}</MemberName>
                    <MemberPosition>
                      {team_member_position && team_member_position.text}
                    </MemberPosition>
                  </MemberSlip>
                </MemberCard>
              )
            })}
          </MembersRow>
        </Container>
        <ParticleLayer params={ParticlesConfig} />
      </Section>
    </Backdrop>
  )
}

Team.propTypes = {
  data: PropTypes.object,
}

export default Team
